// Golden Moth Market — brand assets & tokens
// Transparent logo (Phase 2.5 asset). Optimized transparent WebP copy of the current
// transparent logo (1024x1024, ~0.5MB, alpha preserved). Same artwork/colors/proportions
// as the original 1254x1254 PNG source, which remains available at the URL below.
// Original transparent source (preserved, do not restore the old green-backed logo):
//   https://customer-assets-jai6qajn.emergentagent.net/job_celestial-finds/artifacts/6vmd6v9s_1E39607E-4ABA-44C1-B563-87338D9E1C4D.png
export const TRANSPARENT_LOGO = "/golden-moth-logo.webp";

// Production public domain — used for canonical/sitemap base URLs.
export const SITE_URL = "https://goldenmothmarket.com";

// Deep brand forest green — used behind transparent logo placements
export const BRAND_GREEN = "#061C0F";
